import { TermsAndCondtionsType } from './terms-and-condtions-type.enum';

export class TermsAndCondtion {
  constructor(
    public termsAndCondtions: string,
    public showTermsAndCondtions: boolean,
    public termsAndCondtionsType: TermsAndCondtionsType
  ) {}
}
